
; (function () {
    angular.module("EMR.SelectExternalCaseManager", []);


    var SelectExternalCaseManagerRoutes = [
        {
            "name": "SelectExternalCaseManager",
            "templateUrl": "<div emr-patient-external-case-manager-popup></div>",
            "RoutingNumber": 2740,
            files: [
                "AngularScripts/SelectExternalCaseManager/Services/PatientExternalCaseManagerPopupService.js",
                "AngularScripts/SelectExternalCaseManager/Directives/PatientExternalCaseManagerPopupDirective.js",
            ]
        }
    ];

    angular.module('EMR.SelectExternalCaseManager')
        .config(["$stateProvider", "EmrRouteProvider",
            function ($stateProvider, EmrRouteProvider) {
                EmrRouteProvider.registerStates(SelectExternalCaseManagerRoutes, $stateProvider);
            }]);
})();